module.exports = __webpack_public_path__ + "dfd69eeca3caff6ac5372b1391a38995.pdf";